/**
 * @NApiVersion 2.1
 * @NModuleScope TargetAccount
 */
define([
  'N/https',
  'N/search',
  'N/url',
  'N/runtime'
], function (
  https,
  search,
  url,
  runtime
) {
	'use strict';

  var fileName = 'PartLookup.Backend.Model';
  var fnName = '';
  var brandCodes = [
    {
      brandName: 'Whirlpool',
      brandCode: 'WHI'
    },
    {
      brandName: 'Electrolux',
      brandCode: 'FRI'
    },
    {
      brandName: 'GE',
      brandCode: 'GE'
    }
  ];
  var apiEndpointUrl = '';

  function _createBrandedRequests(path, searchValue, queryPrefix, pathSuffix, brandData) {

    var fnName = '_createBrandedRequests';
    var returnData = [];

    try {

      var partLookupEndpoint = _fetchPartsLookupEndpoint();
      log.debug('partLookupEndpoint',partLookupEndpoint);
      if ( !partLookupEndpoint ) {
        return returnData;
      }

      // if we're getting data for a single brand
      if ( !!brandData ) {

        returnData.push(_createRequestHelper(
          partLookupEndpoint,
          path,
          searchValue,
          queryPrefix,
          pathSuffix,
          brandData
        ));

      }

      // if we're getting data for each brand
      else {

        var l = brandCodes.length;

        for ( var i = 0; i < l; i++ ) {
          returnData.push(_createRequestHelper(
            partLookupEndpoint,
            path,
            searchValue,
            queryPrefix,
            pathSuffix,
            brandCodes[i]
          ));
        }
      }


    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;

  }

  function _createRequestHelper(partLookupEndpoint, path, searchValue, queryPrefix, pathSuffix, brandData) {

    var fnName = '_createRequestHelper';
    var brandedRequest = {
      partLookupRequest: {},
      brandData: brandData
    }

    try {

      var brandedPath = path + '/' + brandData.brandCode + '/';

      // some requests use a query string
      // instead of a path for the searchValue
      if ( !!queryPrefix ) {
        brandedPath += queryPrefix;
      }

      brandedPath += searchValue;

      if ( !!pathSuffix ) {
        brandedPath += pathSuffix
      }

      var partLookupUrl = partLookupEndpoint + brandedPath;
  
      var ariNetetPartsAppKey = https.createSecureString({
        input: '{custsecret_arinet_parts_appkey}',
      });
      
      brandedRequest.partLookupRequest.url = partLookupUrl;
      brandedRequest.partLookupRequest.headers = {
        applicationKey: ariNetetPartsAppKey
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return brandedRequest;
  }

  function _fetchModelAssembliesById(model) {

    var fnName = '_fetchModelAssembliesById';
    var returnData = [];

    try {


      var brandedRequest = _createBrandedRequests(
        '/RestAPI/SearchModelAssemblies', // path
        model['ModelId'],                 // searchValue
        '',                               // queryPrefix
        '/true/3',                        // pathSuffix
        model.brandData                   // brandData.brandCode
      );

      var assemblyResponse = https.get(brandedRequest[0].partLookupRequest);
      returnData = JSON.parse(assemblyResponse.body)['Data'] || [];

      /*
          example:
          returnData = [
            {
              "Id": 2319281,
              "Name": "01 - TOP AND CABINET PARTS",
              "ParentId": 1080429,
              "ParentName": "WTW5500BW0",
              "IsParent": false,
              "ImageUrl": "https://cdn.datamanager.arinet.com/image/WHI/3f7b04a1-5732-4d30-ae17-06e0cad8b7a9/Large"
            },
            ...
          ]
      */

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }
    return returnData;
  }

  function _fetchModeAssemblyParts(model, assemblyId) {
    var fnName = '_fetchModeAssemblyParts';
    var returnData = [];

    try {

      var brandedRequest = _createBrandedRequests(
        '/RestAPI/AssemblyInfo',   // path
        model['ModelId'],          // searchValue
        '',                        // queryPrefix
        '/' + assemblyId + '/3',   // pathSuffix
        model.brandData            // brandData.brandCode
      );

      var assemblyPartsResponse = https.get(brandedRequest[0].partLookupRequest);
      var assemblyPartsData = JSON.parse(assemblyPartsResponse.body)['Data'];

      return {
        Parts: assemblyPartsData['Parts'] || [],
        HotSpots: assemblyPartsData['HotSpots'] || []
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;
  }

  function _fetchModelIdByName(modelSearchInput) {

    var fnName = '_fetchModelIdByName';
    var returnData = [];

    try {

      var brandedRequests = _createBrandedRequests(
        '/RestAPI/SearchModel', // path
        modelSearchInput,       // searchValue
        '',                     // queryPrefix
        '',                     // pathSuffix
        ''                      // brandCode
      );

      var l = brandedRequests.length;

      if ( !l ) {
        return returnData;
      }

      // make a request for each brandcode
      for ( var i = 0; i < l; i++ ) {

        var currentRequest = brandedRequests[i].partLookupRequest;
        var currentBrandData = brandedRequests[i].brandData;
        var partLookupResponse = https.get(currentRequest);
        var data = JSON.parse(partLookupResponse.body)['Data'];

        /*
          example:
          data = {
            "Data": {
              "ModelSearchText": "WTW5500BW",
              "PartSearchText": null,
              "TotalNumberOfResults": 1,
              "Page": 1,
              "PageSize": 50,
              "Results": [
                {
                  "ModelId": 1080429,
                  "ModelName": "WTW5500BW0"
                }
              ]
            },
            "ErrorMessage": null
          }
        */

        var results = data['Results'] || [];
        var ll = results.length;
  
        // for each brandcode, handle the results
        if ( !!ll ) {

          for ( var ii = 0; ii < ll; ii++ ) {

            var currentModel = results[ii];
            var modelId = currentModel['ModelId'] || '';
            var modelName = currentModel['ModelName'] || '';
  
            if ( !!modelId && !!modelName ) {
              currentModel['link'] = '/model-search/' + modelName;
              currentModel['brandData'] = currentBrandData;

              /*
                example:
                currentModel = {
                  "ModelId": 1080429,
                  "ModelName": "WTW5500BW0",
                  "link": "/model-search/WTW5500BW0",
                  "brandData": {
                    "brandName": "Whirlpool",
                    "brandCode": "WHI"
                  }
                }
              */
              returnData.push(currentModel);
            }

          }
        }        
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;
  }
  // ADD this new function before the return statement
  function _resolveModelSearchInput(modelSearchInput) {
    var fnName = '_resolveModelSearchInput';
    var user = runtime.getCurrentUser();
    log.error('PartLookup role check', {
      userId: user.id,
      role: user.role,
      roleId: user.roleId
    });
    try {
      // Search NS items where either model number field matches the input
      var itemSearchObj = search.create({
        type: 'item',
        filters: [
          ['isinactive', 'is', 'F'],
          'AND',
          ['isonline', 'is', 'T'],
          'AND',
          [
            ['custitem_sep_parent_model_number', 'is', modelSearchInput],
            'OR',
            ['custitem_sep_parent_model_number2', 'is', modelSearchInput]
          ]
        ],
        columns: [
          'custitem_sep_parent_model_number',
          'custitem_sep_parent_model_number2'
        ]
      });

      var resolvedInput = modelSearchInput; // default: use as-is

      itemSearchObj.run().each(function(result) {
        var field1 = result.getValue({ name: 'custitem_sep_parent_model_number' });
        var field2 = result.getValue({ name: 'custitem_sep_parent_model_number2' });

        // If the user searched by field2 (alias), resolve to field1 (primary)
        // because AriNet only knows the primary model number
        if (
            field2 &&
            field2.toUpperCase() === modelSearchInput.toUpperCase() &&
            field1
        ) {
          resolvedInput = field1;
          return false; // stop iteration, found a match
        }

        return true;
      });

      return resolvedInput;

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
      return modelSearchInput; // safe fallback
    }
  }
  function _fetchPartsLookupEndpoint() {
    var fnName = '_fetchPartsLookupEndpoint';

    try {

      if ( !apiEndpointUrl ) {
        var ariNetBaseUrl = https.createSecureString({
          input:
            'https://servicesstg.arinet.com/PartStream/RestAPIEndPoint/?appkey=',
        });
        log.debug('ariNetBaseUrl', ariNetBaseUrl)
    
        var ariNetAppKey = https.createSecureString({
          input: '{custsecret_airnet_appkey}',
        });
        log.debug('ariNetAppKey', ariNetAppKey)
        // note - you cannot append a string to a secure string using native JS
        // you must use a NS method to concat regular strings w/ secure strings
        // see https://stackoverflow.com/questions/77440422/testing-secrets-in-netsuite-suitescript-for-api-keys
        // see https://docs.oracle.com/en/cloud/saas/netsuite/ns-online-help/section_4418286676.html#https.SecureString
        var secureApiEndpointUrl = ariNetBaseUrl.appendSecureString({
          secureString: ariNetAppKey,
        });

        log.debug('secureApiEndpointUrl', secureApiEndpointUrl)
        var endpointLookupResponse = https.get({
          url: 'https://servicesstg.arinet.com/PartStream/RestAPIEndPoint/?appkey=l6i0qyUFngNxmkfspYrG'//secureApiEndpointUrl
        });
        log.debug('endpointLookupResponse', endpointLookupResponse)

        if ( !!endpointLookupResponse.body ) {
          apiEndpointUrl = endpointLookupResponse.body;
        }
        log.debug('endpointLookupResponse.body',endpointLookupResponse.body);
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    // return ariNetUrl;
    return apiEndpointUrl;

  }

  function _fetchPlpData(nsItems) {
    var fnName = '_fetchPlpData';
    var returnData = {
      hasItems: false,
      items: [],
    };

    try {

      var endpoint = 'https://www.appliancepartscompany.com/api/cacheable/items';
      var idFilters = '';
      var l = nsItems.length;

      for (var i = 0; i < l; i++) {
        idFilters += nsItems[i].nsInternalId;

        if (i !== l - 1) {
          idFilters += ',';
        }
      }

      var params = {
        id: idFilters,
        c: '4347112',
        country: 'US',
        currency: 'USD',
        fieldset: 'search',
        language: 'en',
        n: '2',
      };

      var itemSearchApiUrl = url.format({
        domain: endpoint,
        params: params,
      });

      var response = https.get({
        url: itemSearchApiUrl,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-SC-Touchpoint': 'shopping',
          'Accept': 'application/json',
          'Accept-encoding': 'gzip,deflate,sdch',
        },
      });

      if (response.body.toLowerCase() === 'not acceptable') {
        return returnData;
      }

      var body = JSON.parse(response.body);

      if (body.hasOwnProperty('items')) {
        returnData = {
          hasItems: true,
          items: body.items,
        };
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;
  }

  function _populateAssemblyItems(assemblyParts, nsItems, plpItems) {
    var fnName = '_populateAssemblyItems';
    var returnData = assemblyParts;

    try {

      var l = returnData.length;

      for (var i = 0; i < l; i++) {
        var nsItem = _findObjectInArray(nsItems, 'sku', returnData[i]['Sku']);

        if (!!nsItem) {
          returnData[i].internalid = nsItem.nsInternalId;

          var plpItem = _findObjectInArray(
            plpItems,
            'internalid',
            nsItem['nsInternalId']
          );

          if (!!plpItem) {
            returnData[i].canPurchase = true;

            for (var prop in plpItem) {
              returnData[i][prop] = plpItem[prop];
            }
          } else {
            returnData[i].canPurchase = false;
          }
        } else {
          returnData[i].internalid = 0;
          returnData[i].canPurchase = false;
        }
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;
  }

  function _searchForAssemblyPartsInNs(assemblyItems) {
    var fnName = '_searchForAssemblyPartsInNs';
    var returnData = [];

    try {
      var externalIdFilters = [];
      var l = assemblyItems.length;

      for (var i = 0; i < l; i++) {
        var sku = assemblyItems[i]['Sku'];

        if (!!sku) {
          externalIdFilters.push(['externalidstring', 'is', sku]);
          externalIdFilters.push('OR');
          externalIdFilters.push(['itemid', 'is', sku]);
          externalIdFilters.push('OR');
        }
      }

      externalIdFilters.pop();

      var itemSearchObj = search.create({
        type: 'item',
        filters: [
          ['isinactive', 'is', 'F'],
          'AND',
          ['isonline', 'is', 'T'],
          'AND',
          [externalIdFilters],
        ],
        columns: ['internalid', 'externalid', 'itemid'],
      });

      itemSearchObj.run().each(function (result) {
        var nsItemId = result.getValue({ name: 'itemid' });
        var nsItem = _findObjectInArray(assemblyItems, 'Sku', nsItemId);

        if (!!nsItem) {
          returnData.push({
            nsInternalId: result.id,
            sku: nsItemId,
          });

          return true;
        }

        var nsExternalId = result.getValue({ name: 'externalid' });
        nsItem = _findObjectInArray(assemblyItems, 'Sku', nsExternalId);

        if (!!nsItem) {
          returnData.push({
            nsInternalId: result.id,
            sku: nsExternalId,
          });
        }

        return true;
      });

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;
  }



  function _findObjectInArray(arr, key, value) {
    var fnName = '_findObjectInArray';
    var returnData = null;

    try {

      for (var i = 0; i < arr.length; i++) {
        if (arr[i][key] == value) {
          returnData = arr[i];
          break;
        }
      }

    } catch(error) {
      log.error(fileName + ' ' + fnName, error);
    }

    return returnData;
  }


	return {

    getModelInfo: function (request) {
			var modelSearchInput = request.parameters.modelSearchInput;

			// if search has no value
			if ( !modelSearchInput ) {
				throw {
          status: 401,
          message: 'Please provide a model number'
        }
		}
      var resolvedModelSearchInput = _resolveModelSearchInput(modelSearchInput);
      log.debug('modelSearchInput resolved', modelSearchInput + ' -> ' + resolvedModelSearchInput);

      var modelData = _fetchModelIdByName(modelSearchInput);

      // no matches found
      if ( !modelData.length ) {
        return [];
        return {
          modelName: null,
          modelId: null,
          modelAssemblies: [],
          brandData: ''
        }
      }

      // multiple matches found
      // todo 
      // if ( !modelData.length > 1 ) {
      //   return {};
      // }

      // exact match found
      var model = modelData[0];
      var modelAssemblies = _fetchModelAssembliesById( model );

      return {
        modelName: model['ModelName'],
        modelId: model['ModelId'],
        modelAssemblies: modelAssemblies,
        brandData: model.brandData
      };
		},

    getAssemblyInfo: function (request) {

      var brandCode = request.parameters.brandCode;
      var brandName = request.parameters.brandName;
      var modelId = request.parameters.modelId;
      var selectedAssemblyId = request.parameters.selectedAssemblyId;

			// if search has no value
			if ( !selectedAssemblyId ) {
				throw {
          status: 401,
          message: 'Please provide a part number'
        }
			}

      var model = {
        ModelId: modelId,
        brandData: {
          brandCode: brandCode,
          brandName: brandName,
        }
      }

      var assemblyParts = _fetchModeAssemblyParts(
        model,
        selectedAssemblyId
      );

      /*
          example:
          assemblyParts = {
            AssemblyId: 2319281,
            Name: 01 - TOP AND CABINET PARTS,
            ParentId: 1080429,
            ParentName: WTW5500BW0,
            Parts: [
              {
                "PartId": 23193665,
                "Sku": "W10063002",
                "Description": "ENERGY GUIDE",
                "Context": "",
                "MSRP": 0,
                "DealerCost": 0,
                "IsSuperseded": false,
                "OrgSku": null,
                "OrgDescription": null,
                "OrgMSRP": null,
                "Qty": "",
                "SortTag": "01",
                "Tag": "1",
                "NLA": false,
                "ImageUrl": null
              },
              ...
            ],
            ImageUrl: https://cdn.datamanager.arinet.com/image/WHI/3f7b04a1-5732-4d30-ae17-06e0cad8b7a9/Large?ariz=3,
            ZoomLevel: 3,
            HotSpots: [
              {
                "Tag": "1",
                "TopLeft": {
                  "X": 130,
                  "Y": 228
                },
                "BottomRight": {
                  "X": 159,
                  "Y": 261
                }
              },
              ...
            ]
          }
      */

      var selectedAssembly = {};

      // for the items in the response, find the
      // corresponding items in NS
      var nsItems = _searchForAssemblyPartsInNs(assemblyParts.Parts);

      // for the items in NS, get their PLP/PDP data
      var plpData = _fetchPlpData(nsItems);
      
      // get the plp/pdp data into the response
      if (plpData.hasItems) {

        selectedAssembly['assemblyItems'] =
          _populateAssemblyItems(
            assemblyParts.Parts,
            nsItems,
            plpData.items
          );
      }

      // otherwise, we will show all out of stock items
      else {
        selectedAssembly['assemblyItems'] = assemblyParts.Parts;
      }

      selectedAssembly['hotspots'] = assemblyParts.HotSpots;

      return {
        selectedAssembly: selectedAssembly,
        brandData: model.brandData
      };
	},
    getModelAndAssembly: function(request) {

      var modelInfo = this.getModelInfo(request);

      // if one or more of these properties aren't available,
      // then the getAssemblyInfo method won't work
      if (
        !modelInfo.modelName ||
        !modelInfo.modelId ||
        !modelInfo.modelAssemblies ||
        !modelInfo.brandData
      ) {
        return modelInfo;
      }

      // these params aren't in the request, so just make
      // an object in the shape of what getAssemblyInfo expects
      var fauxRequest = {
        parameters: {
          modelId: modelInfo.modelId,
          selectedAssemblyId: request.parameters.selectedAssemblyId,
          brandCode: modelInfo.brandData.brandCode,
          brandName: modelInfo.brandData.brandName,
        }
      }

      var assemblyInfo = this.getAssemblyInfo(fauxRequest);

      // combine the two objects
      for ( var prop in assemblyInfo ) {
        modelInfo[prop] = assemblyInfo[prop];
      }


      return modelInfo;

    }

	};
});
